/**
 * The visitor's cookie choice, kept on their own device and nowhere else.
 *
 * Two categories only, because that is all this site has: what it needs to work (your county, your saved
 * comparisons, an admin session) and an anonymous page count with no identifier attached. There is no
 * advertising, no cross-site tracking and no profiling to ask about, so none is invented here.
 */
const KEY = "kskf_cookie_choice";
export const CHANGED = "kskf-cookie-choice-changed";

export const CATEGORIES = [
  {
    id: "essential",
    label: "What the site needs to work",
    detail:
      "Remembers the county you picked, the comparisons you saved and, for staff, a signed-in session. Kept on your device and cleared when you close the tab or press Clear my selections.",
    locked: true,
  },
  {
    id: "analytics",
    label: "Anonymous page counts",
    detail:
      "Counts that a page was viewed, on our own server. No name, no address, no identifier, no third party, and nothing that can be traced back to you.",
    locked: false,
  },
];

export const readChoice = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/** Counts run until someone declines: an anonymous aggregate count, switched off the moment it is refused. */
export const analyticsAllowed = () => readChoice()?.analytics !== false;

export const hasDecided = () => !!readChoice()?.decided_at;

export const saveChoice = (analytics) => {
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ analytics: !!analytics, decided_at: new Date().toISOString(), version: 1 }),
    );
  } catch {
    /* a visitor blocking storage is a valid answer in itself */
  }
  window.dispatchEvent(new CustomEvent(CHANGED));
};

export const reopenSettings = () => window.dispatchEvent(new CustomEvent(CHANGED, { detail: { reopen: true } }));
